import { AlertProps as MuiAlertProps } from '@mui/material/Alert';
import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { BoundFunctions } from '@testing-library/react';
import { Dispatch, SetStateAction } from 'react';

import Icons from '@Constants/Icons.constants';

export type IconsObj = Record<string, JSX.Element>;

export type Icon = keyof typeof Icons;

// error states ------------
export type CustomError = {
  message: string | undefined;
  severity: MuiAlertProps['severity'];
  status?: number;
  errorPayload?: SerializedError | FetchBaseQueryError;
  errorData?: ErrorData;
};

export type BaseAlertProps = {
  openAlert: boolean;
  message?: string;
  severity?: MuiAlertProps['severity'];
  resetAlert?: Dispatch<
    SetStateAction<{
      openAlert: boolean;
      message?: string;
      severity?: MuiAlertProps['severity'];
    }>
  >;
};
export type CommonApiError = {
  errors: string[];
  message: string;
  success: false;
};

export type ErrorPayload = {
  message: string;
};

export type ErrorData = {
  status: number | string;
  data: Data;
  originalStatus?: number;
};

export type Data = {
  success: boolean;
  message: string;
  errors?: string[] | null;
};

export type GlobalAlert = {
  isVisible: boolean;
  error: CustomError | undefined;
};

// error states -----------------

export type ReactHookFormError = {
  [x: string]: string;
};

// Test Types -------------
export type BoundContainer = BoundFunctions<
  typeof import('@testing-library/dom/types/queries')
>;

// Test Types -------------

export enum DialerTypes {
  Active = 'active',
  Archived = 'archived',
  Favorites = 'favorites',
}

export enum DialerCrudTypes {
  Add = 'add',
  View = 'view',
  Edit = 'edit',
  Archive = 'archive',
  Preview = 'preview',
}

export enum ReportTypes {
  CallLog = 'call-log',
  Sessions = 'sessions-summary',
  ActiveSessions = 'active-sessions',
  EmailLog = 'email-log',
}

export enum VoiceProviderTypes {
  Both = 'BOTH',
  Vonage = 'VONAGE',
  Twilio = 'TWILIO',
  Telnyx = 'TELNYX',
}

export enum ConfirmationActionTypes {
  Save = 'save',
  Delete = 'delete',
  Archive = 'archive',
  Unarchive = 'unarchive',
  Restore = 'restore',
  BleedOut = 'bleedOut',
  EndSession = 'endSession',
}

export interface HeaderCheckboxState {
  checked: boolean;
  indeterminate: boolean;
}

export interface PasteEvent {
  clipboardData: {
    types: string[];
    getData: (type: string) => string;
  };
}

export interface SSOLogin {
  refreshToken: string | null;
  redirectToPath?: string;
}

export enum RotationCallerIdSource {
  TWILIO = 'twilio',
  OWN = 'own',
  TELNYX = 'telnyx',
}

export enum RotationPhoneTypes {
  SYSTEM = 'system',
  OWN = 'own',
}

export enum FeatureFlagTypes {
  BLEED_OUT_MODE = 'Bleed Out Mode',
  CALL_TIME_FRAME = 'Call Time Frame',
  CALL_DURATION_MONITORING = 'Call Duration Monitoring',
}

export enum AccountSettingTypes {
  IS_RINGING_ENABLED = 'is ringing enabled',
}

export enum PhoneDispositions {
  DO_NOT_CALL = 'Do Not Call',
  NONE = 'None',
}
